import React, { useEffect, useState } from "react";
import { Form, Input, Button, Typography, DatePicker, Row, Col, message, Spin } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import { routes } from "../../routes/Routes";
import { RightOutlined } from '@ant-design/icons';
import _LoanOfficerService from "../../modules/LoanOfficerService";
import { COMMON_ERROR_MSG } from "../../constants/constants";
import IntegerInput from "../../components/IntergerInput";
import _NewapplicationService from "../../modules/NewapplicationService";
import HeaderComponentWithTitleAndLogo from "../../components/HeaderComponentWithTitleAndLogo/HeaderComponentWithTitleAndLogo";
import MainLayout from "../../components/MainLayout/MainLayout";
import ForgotPassword from "../../components/Password/ForgotPassword";

const { Title, Text, Link } = Typography;

const ForgotLoanOfficerPassword = () => {
    const history = useHistory();
    const location = useLocation();

    let data = location.state;
    let emailId = "";
    if (data && data.email) {
        emailId = data.email;
    }
    const fromNewLoginPage = data?.fromNewLoginPage || null;

    const [email] = useState(emailId);
    const [loading, setLoading] = useState(false);
    const [timer, setTimer] = useState(120);

    const onFinish = async (values) => {

        setLoading(true);
        try {
            const reqObj = {
                Email: email,
                EmailOTP: values.otp,
                NewPassword: values.newPassword,
                ConfirmPassword: values.confirmPassword,
            }
            const res = await _LoanOfficerService.forgotLoanOfficerPassword(reqObj);
            if (res.data.IsSuccess) {
                message.success(res.data.Message);
                localStorage.setItem("Password", values.newPassword);
                setLoading(false);
                history.push(routes.accountLoginForLoanOfficer.path);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
                setLoading(false);
            }
        } catch (err) {
            console.log(err);
            setLoading(false);
        } finally {
            setLoading(false);

        }
    };

    const validatePassword = (_, value) => {
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#@%&!^*.,_+=?]).{8,20}$/;
        if (!value || passwordRegex.test(value)) {
            return Promise.resolve();
        }
        return Promise.reject(
            new Error(
                "Password must include uppercase, lowercase, number, special character and be 8-20 characters long"
            )
        );
    };

    useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => setTimer((t) => t - 1), 1000);
            return () => clearInterval(interval);
        }
    }, [timer]);


    const handleResendOtp = async () => {
        let reqObj = {
            Email: email,
            Role: "loanofficer"
        }
        setLoading(true);
        try {
            const res = await _NewapplicationService.forgotPasswordSendEmailOTP(reqObj);
            if (res.data.IsSuccess) {
                setTimer(120);
                message.success(res.data.Message || "OTP Sent Successfully");
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };

    return (
        <Spin spinning={loading}>


             <MainLayout>
                <HeaderComponentWithTitleAndLogo
                    logoSrc="/websiteLogo.png"
                    logoAlt="Leveridge Logo"
                    title="Create New Password"
                />
                <ForgotPassword 
                    email={email}
                    onFinish={onFinish}
                    validatePassword={validatePassword}
                    timer={timer}
                    handleResendOtp={handleResendOtp}
                    loading={loading}
                    goBackLinkLable="Login"
                    goBackOnClick={() => history.push(fromNewLoginPage || routes.accountLoginForLoanOfficer.path)}
                />
            </MainLayout>
            {/* <LeftLayout>
                <div className="w450">
                    <Title level={3} style={{ fontWeight: "bold", color: "#d3d3d3", marginBottom: 60 }}>
                        Loan Officer’s Portal
                    </Title>

                    <Title level={4} style={{ marginBottom: 24 }}>
                        Forgot Password
                    </Title>

                    <Form
                        layout="vertical"
                        onFinish={onFinish}
                        requiredMark={true}
                    >
                        <Text type="secondary" style={{ display: "block", marginBottom: 24 }}>
                            A six digit Verification Code was sent to <Text strong>{email}</Text>
                        </Text>

                        <Form.Item
                            label="Enter Verification Code" 
                            name="otp"
                            rules={[{ required: true, message: "OTP is required" },
                            {
                                pattern: /^\d{6}$/,
                                message: "OTP must be a 6-digit number",
                            },
                            ]}
                        >
                            <IntegerInput
                                maxLength={6}
                                placeholder="Enter 6-digit OTP"
                                autoComplete="one-time-code"
                            />
                        </Form.Item>

                        <Form.Item
                            label="New Password"
                            name="newPassword"
                            rules={[
                                { required: true, message: "New Password is required" },
                                { validator: validatePassword }
                            ]}

                        >
                            <Input.Password maxLength={20} placeholder="Enter New Password" />
                        </Form.Item>

                        <Form.Item
                            label="Confirm Password"
                            name="confirmPassword"
                            dependencies={["newPassword"]}

                            rules={[
                                { required: true, message: "Confirm Password is required" },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue("newPassword") === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error("Passwords do not match"));
                                    }
                                })
                            ]}
                        >
                            <Input.Password maxLength={20} placeholder="Enter Confirm Password" />
                        </Form.Item>

                        <Form.Item style={{ marginTop: 32 }}>
                            <Button
                                htmlType="submit"
                                shape="round"
                                style={{
                                    fontWeight: "bold"
                                }}
                            >
                                Save  <RightOutlined />
                            </Button>
                        </Form.Item>


                        <Text type="secondary" style={{ display: "block", marginTop: 30 }} className="mb-10">
                            Please wait 120 seconds before resending a new OTP:{" "}
                            <span style={{ fontWeight: "bold"}}>
                                00:{timer.toString().padStart(2, "0")}
                            </span>
                        </Text>
                        <Button shape="round" disabled={timer > 0} onClick={handleResendOtp}>Resend</Button>
                    </Form>

                    <Row justify="space-between" style={{ marginTop: 32 }}>
                        <Col>
                            <Link onClick={() => history.push(routes.accountLoginForLoanOfficer.path)} style={{ fontWeight: "bold" }}>
                                Login <RightOutlined />
                            </Link>
                        </Col>
                        <Col className="displayNone">
                            <Link onClick={() => history.push(routes.enterEmailForLoanOfficer.path)} style={{ fontWeight: "bold" }}>
                                Create A New Account <RightOutlined />
                            </Link>
                        </Col>
                    </Row>
                </div>
            </LeftLayout> */}
        </Spin>
    );
};

export default ForgotLoanOfficerPassword;